import moment from 'moment';

import 'moment/min/locales.min';

moment.locale(process.env.REACT_APP_CURRENT_LANGUAGE, {
  week: {
    dow: 0,
    doy: 0
  }
});

const DATE_FORMAT = 'DD/MM/YYYY';

export const getDate = (dateTime, format = DATE_FORMAT) => moment.utc(dateTime).format(format);
